import { render, staticRenderFns } from "./AddOrEditMedicine.vue?vue&type=template&id=2b53e7b4"
import script from "./AddOrEditMedicine.vue?vue&type=script&lang=js"
export * from "./AddOrEditMedicine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports